<template>
  <div class="information">
    <div class="info-top">
      <div class="mess-con">
        <!-- <img src="@/assets/my/head.jpg" alt=""> -->
         <div class="mess-text">
          <div class="top-mess">{{Interformation.InformationExchange}}</div>
          <!-- <div class="top-message">{{Interformation.InformationExchangeTxt}}</div> -->
         </div>
      </div>
    </div>
    <!-- <div class="bot-cont" id="section1">
      <div class="info-bot">
        <div class="bot-line"></div>
        <div class="bot-tit">
          {{Interformation.InternationalNews}}
          <div class="bot-bg">International News</div>
        </div>
        <div class="bot-input">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="">
              <el-date-picker
                v-model="formInline.time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.country" clearable placeholder="国家">
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in timeGJ"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                clearable
                v-model="formInline.keyword"
                prefix-icon="el-icon-search"
                placeholder="请输入关键词"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="onSearch"
                style="background: #1b3e92"
                >{{Interformation.Search}}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="bot-all">
          <template v-if="listData.length > 0">
            <div class="items" v-for="(item, index) in listData" :key="index">
              <div class="item">
                <div class="item-left">{{ item.news_date }}</div>
                <div class="item-right">
                  <div class="titles" @click="toNewPage(item)">
                    {{ item.title }}
                  </div>
                  <div class="context">
                    {{ item.content }}
                  </div>
                </div>
              </div>
              <div class="line"></div>
            </div>
          </template>
          <template v-else>
            <div style="padding-bottom: 50px">暂无数据</div>
          </template>
          <div class="pagination">
            <div class="page-text" v-if="total > 0">共 {{ total }} 条</div>
            <el-pagination
              v-show="total > 0"
              background
              :pager-count="5"
              layout="prev, pager, next"
              @current-change="(value) => handleCurrentChange(value,'section1')"
              @size-change="sizeChange"
              :current-page="page"
              :page-size="size"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div> -->
    <div class="info-bot" id="section2">
      <!-- <div class="bot-line"></div>
      <div class="bot-tit">
        {{Interformation.GlobalTrends}}
        <div class="bot-bg">International News</div>
      </div>
      <div class="earth">
        <div class="show-earth">
          <div class="show-title">全球人工智能企业数量</div>
          <div class="show-content">
            <div class="left">
              <div v-for="item in mockList.slice(0, 5)" :key="item.name">
                <img :src="require(`@/assets/home/${item.cnName}.png`)" alt="">
                <div v-if="yy === 'zh'">{{ item.cnName }}：</div>
                <div v-else>{{ item.labelText }}：</div>
                <div class="number">{{ item.number }}</div>
                <div>家</div>
              </div>
            </div>
            <div class="earth-con">
              <div
                id="container"
                ref="container"
                style="width: 100%; height: 600px"
              ></div>
            </div>
            <div class="right">
              <div v-for="item in mockList.slice(5, 10)" :key="item.name">
                <img :src="require(`@/assets/home/${item.cnName}.png`)" alt="">
                <div v-if="yy === 'zh'">{{ item.cnName }}：</div>
                <div v-else>{{ item.labelText }}：</div>
                <div class="number">{{ item.number }}</div>
                <div>家</div>
              </div>
            </div>
            <div class="new-box">
              <div class="new-child" v-for="item in mockList" :key="item.name">
                <img :src="require(`@/assets/home/${item.cnName}.png`)" alt="">
                <div>{{ item.cnName }}：</div>
                <div class="number">{{ item.number }}</div>
                <div>家</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="bot-input">
        <div class="trend-input">
          <div class="input-left">
            <div class="left-name">{{Interformation.category}}：</div>
            <div class="left-btn">
              <div
                :class="isActive == 'all' ? 'isactive' : ''"
                @click="typeBtn('all')"
              >
              {{Interformation.all}}
              </div>
              <div
                :class="isActive == '技术趋势' ? 'isactive' : ''"
                @click="typeBtn('技术趋势')"
              >
              {{Interformation.TechnologyTrends}}
              </div>
              <div
                :class="isActive == '产业趋势' ? 'isactive' : ''"
                @click="typeBtn('产业趋势')"
              >
              {{Interformation.IndustryTrends}}
              </div>
              <div
                :class="isActive == '政策趋势' ? 'isactive' : ''"
                @click="typeBtn('政策趋势')"
              >
              {{Interformation.PolicyTrends}}
              </div>
            </div>
          </div>
          <el-form :inline="true" :model="formTrend" class="demo-form-inline">
            <el-form-item label="">
              <el-date-picker
                v-model="formTrend.time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-select clearable v-model="formTrend.country" placeholder="国家">
                <el-option
                  :label="$i18n.locale === 'zh' ? item.country : item.english_country"
                  :value="item.country"
                  v-for="(item, index) in timeQs"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                clearable
                v-model="formTrend.keyword"
                prefix-icon="el-icon-search"
                placeholder="请输入关键词"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="onSearchTrend"
                style="background: #1b3e92;border: 1px solid #1b3e92;"
                >{{Interformation.Search}}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="bot-all" style="margin-bottom: 60px;">
        <template v-if="listDataQs.length > 0">
          <div class="items" v-for="(item, index) in listDataQs" :key="index" @click="goDetail(item, 'industry')">
            <div class="item">
              <div class="item-qu">{{ $i18n.locale === 'zh' ? item.type : item.english_type }}</div>
              <div class="item-left">{{ $i18n.locale === 'zh' ? item.news_date : formatDate(item.news_date) }}</div>
              <div class="item-right">
                <div class="titles">
                  {{ $i18n.locale === 'zh' ? item.title : item.english_title }}
                </div>
                <div class="context">
                  {{ $i18n.locale === 'zh' ? item.content : item.english_content }}
                </div>
              </div>
            </div>
            <div class="line"></div>
          </div>
        </template>
        <template v-else>
          <div style="padding-bottom: 50px">暂无数据</div>
        </template>
        <div class="pagination">
          <div class="page-text" v-show="totalQs > 0">{{Interformation.Total}} {{ totalQs }} {{ Interformation.items }}</div>
          <el-pagination
            v-show="totalQs > 0"
            background
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="(value) => handleCurrentChangeQs(value,'section2')"
            @size-change="sizeChangeQs"
            :current-page="pageQs"
            :page-size="sizeQs"
            :total="totalQs"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mock from "../../../public/json/信息交流-国际资讯.json";
import mock2 from "../../../public/json/信息交流-全球趋势.json";
import mock3 from "../../../public/json/金砖国家经纬度.json";
export default {
  data() {
    return {
      formInline: {
        time: "",
        country: "",
        keyword: "",
      },
      formTrend: {
        time: "",
        country: "",
        keyword: "",
      },
      isActive: "all",
      dataGJzx: "", //国际资讯
      listData: "",
      total: 100,
      page: 1, // 当前页码
      size: 5, // 每页显示的条目数
      totalQs: 100,
      pageQs: 1, // 当前页码
      sizeQs: 5, // 每页显示的条目数
      listDataQs: "",
      dataQs: "", //全球趋势
      timeGJ: [],
      timeQs: [],
      sectionId:'',
      imgBg: require("@/assets/home/earth-bg.jpg"),
      mockList: mock3['dataset2'],
      yy: localStorage.getItem('yy') || 'zh',
    };
  },
  computed:{
    Interformation(){
      return this.$t('Interformation')
    }
  },
  watch:{
    // sectionId(newId,oldval){
    //   console.log(newId,'---newId',oldval)
    //   this.$nextTick(() => {
    //     this.scrollTo(newId);
    //   });
    // }
  },
  created(){
    this.initializeEventListener();
  },
  mounted() {
    this.dataGJzx = mock["RECORDS"];
    this.dataGJzx.forEach((element) => {
      this.timeGJ.push(element.country);
    });
    this.timeGJ = [...new Set(this.timeGJ)];
    this.dataQs = mock2["RECORDS"];
    this.dataQs.forEach((element) => {
      this.timeQs.push(element);
    });
    this.timeQs = this.timeQs.filter((value, index, self) => {
      return self.findIndex(item => item.country === value.country) === index;
    })
    this.timeQs = this.timeQs.filter((item) => !!item.country);
    this.getData();
    this.getDataQs();
    // this.init()
  },
  methods: {
    init() {
      // 获取元素
      let dom = document.getElementById("container");
      // 初始化echarts
      let myChart = this.$echarts.init(dom);
      // 地球数据显示
      console.log(mock3, "mock3");
      
      let ds = mock3['dataset1'];


      // 点配置信息
      let series = ds.map((item,index) => {
          return {
              name: item.name, // 是否显示左上角图例
              type: 'scatter3D',
              coordinateSystem: 'globe',
              blendMode: 'lighter',
              symbolSize: 5, // 点位大小
            
              itemStyle: {
                  color: item.itemStyleColor, // 各个点位的颜色设置
                  opacity: 1, // 透明度
                  borderWidth: 1, // 边框宽度
                  borderColor: 'rgba(255,255,255,0.8)' //rgba(180, 31, 107, 0.8)
              },
              label: {
                  show: true, // 是否显示字体
                  position: index % 2 === 0 ? 'left' : 'right', // 字体位置。top、left、right、bottom
                  formatter: this.yy === 'zh' ? (`${item.cnName}(${item.number})`) : (`${item.labelText}(${item.number})`), // 具体显示的值
                  textStyle: {
                      color: '#000', // 字体颜色
                      borderWidth: 0, // 字体边框宽度
                      borderColor: '#fff', // 字体边框颜色
                      fontFamily: 'sans-serif', // 字体格式
                      fontSize: 12, // 字体大小
                      fontWeight: 400 // 字体加粗
                  }
              },
              data: [item.point] // 数据来源
          }
      })
      // 添加上面的配置项到地球上
      myChart.setOption({
         
          // 图例设置
          legend: {
              show: false, // 是否显示左上角图例
              selectedMode: 'multiple',
              x: 'right',
              y: 'bottom',
              data: ds.map(item => {
                  return item.name // 数据来源
              }),
              padding: [0, 200, 140, 0], // 填充位置,上、右、下、左
              orient: 'vertical', // 排列方式，vertical:垂直排列
              textStyle: {
                  color: '#fff', // 文字颜色
              }
          },
          tooltip: {
            show: true,
          },
          // 地球背景色
          // backgroundColor: '#058198',
          // 地球参数设置
          globe: {
              baseTexture: this.imgBg, // 地球表面覆盖的图片,可以替换成自己想要的图片
              shading: 'color', // 地球中三维图形的着色效果
              viewControl: {
                  autoRotate: true, // 是否开启视角绕物体的自动旋转查看
                  autoRotateSpeed: 3, //物体自转的速度,单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                  autoRotateAfterStill: 2, // 在鼠标静止操作后恢复自动旋转的时间间隔,默认 3s
                  rotateSensitivity: 2, // 旋转操作的灵敏度，值越大越灵敏.设置为0后无法旋转。[1, 0]只能横向旋转.[0, 1]只能纵向旋转
                  targetCoord: [116.46, 39.92], // 定位到北京
                  maxDistance: 200,
                  minDistance: 200
              }
          },
          // 地球文字显示信息配置
          series: series
      })
    },
    goDetail(item, type) {
      const query = {
        id: item.id,
        type: type,
        tit1:'信息交流',
        tit2:'了解更多国内外人工智能信息'
      }
      this.$router.push({ path: '/InfoDetail', query })
    },
    initializeEventListener() {
      let that = this;
      this.$bus.$off("changePont");
      this.$bus.$on("changePont", (sectionId) => {
        this.sectionId = sectionId.isPont;
          this.$nextTick(() => {
            that.scrollTo(this.sectionId);
          });
      });
    },
    scrollTo(sectionId) {
      this.$nextTick(()=>{
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      })
    },
    toNewPage(item) {
      window.open(item.url, "_blank");
    },
    getData() {
      let data = JSON.parse(JSON.stringify(this.dataGJzx));
      let filterData = [];
      if (
        this.formInline.time ||
        this.formInline.country ||
        this.formInline.keyword
      ) {
        filterData = data.filter((item) => {
          const matchesKeyword = item.title
            .toLowerCase()
            .includes(this.formInline.keyword.toLowerCase());
          const matchesDate = this.formInline.time
            ? item.news_date === this.formInline.time
            : true;
          const matchesCountry = this.formInline.country
            ? item.country === this.formInline.country
            : true;
          return matchesKeyword && matchesDate && matchesCountry;
        });
      } else {
        filterData = data;
      }
      this.total = filterData.length;
      this.listData = filterData.splice((this.page - 1) * this.size, this.size);
    },
    getDataQs() {
      this.listDataQs = [];
      let data = JSON.parse(JSON.stringify(this.dataQs));
      if (!this.isActive || this.isActive == "all") {
        data = data;
      } else {
        data = data.filter((item) => item.type == this.isActive);
      }
      let filterData = [];
      if (
        this.formTrend.time ||
        this.formTrend.country ||
        this.formTrend.keyword
      ) {
        filterData = data.filter((item) => {
          const matchesKeyword = item.title
            .toLowerCase()
            .includes(this.formTrend.keyword.toLowerCase());
          const matchesDate = this.formTrend.time
            ? item.news_date === this.formTrend.time
            : true;
          const matchesCountry = this.formTrend.country
            ? item.country === this.formTrend.country
            : true;
          return matchesKeyword && matchesDate && matchesCountry;
        });
      } else {
        filterData = data;
      }
      this.totalQs = filterData.length;
      this.listDataQs = filterData.sort((a, b) => {return b.news_date.split('-').join('') - a.news_date.split('-').join('')}).splice(
        (this.pageQs - 1) * this.sizeQs,
        this.sizeQs
      );
    },
    handleCurrentChange(page, id) {
      this.page = page;
      this.getData();
      this.sectionId = id;
      this.scrollTo(this.sectionId);
    },
    handleCurrentChangeQs(page, id) {
      this.pageQs = page;
      this.getDataQs();
      this.sectionId = id;
      this.scrollTo(this.sectionId);
    },
    sizeChange(val) {
      this.page = 1; // 当前页码
      this.size = val;
      this.getData();
    },
    sizeChangeQs(val) {
      this.pageQs = 1; // 当前页码
      this.sizeQs = val;
      this.getDataQs();
    },
    typeBtn(type) {
      this.isActive = type;
      this.pageQs = 1; // 当前页码
      this.getDataQs();
    },
    onSearch() {
      this.getData();
    },
    onSearchTrend() {
      this.getDataQs();
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error('Invalid date format');
        return null;
      }
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.earth {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 60px;
  .show-earth {
    max-width: 1200px;
    width: 100%;
    padding-top: 30px;
    background: linear-gradient(to right, #f9f9f9, #ebf1f7);
    .show-title {
      font-size: 24px;
    }
    .show-content {
      display: flex;
      align-items: center;
      justify-content: center;
      .left, .right {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        &>div {
          img {
            height: 40px;
          }
          display: flex;
          align-items: center;
          font-size: 16px;
          height: 20px;
          line-height: 20px;
        }
        .number {
          font-size: 18px;
        }
      }
      .new-box {
        display: none;
      }
    }
  }
  .earth-con {
    max-width: 600px;
    width: 100%;
    // margin: 0 auto;
  }
}
.information {
  width: 100%;
  ::v-deep .el-input__inner {
    width: 160px !important;
  }
  ::v-deep .el-date-editor.el-input {
    width: 160px;
  }
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
  .bot-cont {
    // background: #f5f7fa;
  }
  .info-bot {
    max-width: 1200px;
    margin: 0 auto;
    // padding: 0 2vw;
    box-sizing: border-box;
    padding-top: 60px;
    box-sizing: border-box;
    .bot-line {
      margin: 0 auto;
      width: 84px;
      height: 4px;
      background: linear-gradient(270deg, #1d3e95 0%, #4840c2 100%);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
    }
    .bot-tit {
      margin: 0 auto;
      margin-top: 22px;
      height: 40px;
      font-family: Inter;
      font-weight: 400;
      font-size: 36px;
      color: #080808;
      line-height: 40px;
      position: relative;
      .bot-bg {
        height: 50px;
        font-family: Inter;
        font-weight: 700;
        font-size: 36px;
        color: rgba(194, 194, 194, 0.12);
        line-height: 50px;
        text-align: center;
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translate(-50%, 0);
        white-space: nowrap;
      }
    }
    .bot-input {
      margin-top: 40px;
      text-align: left;
      .trend-input {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // justify-content: space-between;
        .input-left {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .left-name {
            font-family: Inter;
            font-size: 16px;
            color: #333640;
            text-align: left;
            white-space: nowrap;;
          }
          .left-btn {
            flex: 1 1 0;
            display: flex;
            align-items: center;
            .isactive {
              // width: 100px;
              font-family: Inter;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              text-align: center;
              height: 36px;
              line-height: 36px;
              background: #1b3e92;
              border-radius: 30px;
            }
            > div {
              // width: 100px;
              padding: 0 20px;
              height: 20px;
              font-family: Inter;
              font-weight: 400;
              font-size: 16px;
              color: #61656c;
              line-height: 20px;
              text-align: center;
              margin-right: 4px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .bot-all {
      margin-top: 50px;
      .items {
        .item {
          display: flex;
          font-family: Inter;
          position: relative;
          .item-qu {
            position: absolute;
            left: 3px;
            bottom: 11px;
            width: 112px;
            height: 32px;
            line-height: 32px;
            background: #f7f7fa;
            border-radius: 30px;
            color: #61656c;
            font-size: 16px;
          }
          .item-left {
            white-space: nowrap;
            height: 40px;
            font-family: D-DIN, D-DIN;
            font-weight: 400;
            font-size: 18px;
            color: #3d3d3d;
            line-height: 40px;
            margin-right: 38px;
            min-width: 120px;
            text-align: center;
          }
          .item-right {
            .titles {
              font-weight: 500;
              font-size: 18px;
              color: #333640;
              line-height: 40px;
              text-align: left;
            }
            .context {
              font-size: 16px;
              color: #666666;
              line-height: 40px;
              text-align: left;
              display: -webkit-box;
              -webkit-line-clamp: 2; //显示最大行数
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
        .item:hover {
          .item-left {
            color: #1b3e92;
            cursor: pointer;
          }
          .titles {
            color: #1b3e92;
            cursor: pointer;
          }
          .context {
            color: #1b3e92;
            cursor: pointer;
          }
        }
        .line {
          height: 1px;
          background: #d8d8d8;
          margin: 40px 0px;
        }
      }
      .pagination {
        display: flex;
        justify-content: space-between;
        .page-text {
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
}
::v-deep .el-form {
  white-space: nowrap;
}
::v-deep .el-form-item {
  margin-bottom: 0px;
}
.el-pagination {
  text-align: right;
  // padding-bottom: 100px;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1b3e92;
  color: #fff;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: none !important;
}
::v-deep .el-pagination__total {
  float: left;
  color: #666;
  font-size: 18px;
}
@media (min-width: 600px) and (max-width: 1040px) {
  
}
@media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    display: none !important;
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .bot-all {
    padding: 0 20px;
    box-sizing: border-box;
    .item-left {
      display: none !important;
    }
    .item-qu {
      display: none !important;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
    .input-left {
      // padding-left: 6px;
      padding-left: 4vw !important;
      box-sizing: border-box;
    }
  }
  .page-text {
    min-width: 80px !important;
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .left-btn {
    &>div {
      // width: 60px !important;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .isactive {
      width: 100px !important;
    }
  }
  .pagination {
    flex-direction: column;
    align-items: flex-end;
    .page-text {
      margin-bottom: 10px;
    }
  }
  .mess-con {
    height: 150px !important;
    // padding: 0 2vw;
    box-sizing: border-box;
  }
  .left-name {
    display: none;
  }
  .left-btn {
    &>div {
      padding: 0 10px !important;
      width: auto !important;
    }
    .isactive {
      // width: 100px;
      width: auto !important;
      padding: 0 10px !important;
    }
  }
  .earth {
    .show-content {
      flex-direction: column !important;
      .new-box {
        display: flex !important;
        flex-wrap: wrap;
        justify-content: center;
        padding-bottom: 20px;
      }
      .new-child {
        display: flex !important;
        align-items: center;
        width: 180px;
        margin-bottom: 8px;
        img {
          height: 20px !important;
        }
      }
    }
    // display: none !important;
    .left,.right {
      display: none !important;
    }
    #container {
      height: 400px !important;
    }
  }
}
</style>
